/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsnav1Inputs */

const en_groupsnav1 = /** @type {(inputs: Groupsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group chats`)
};

const de_groupsnav1 = /** @type {(inputs: Groupsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppenchats`)
};

/**
* | output |
* | --- |
* | "Group chats" |
*
* @param {Groupsnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsnav1 = /** @type {((inputs?: Groupsnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsnav1(inputs)
	return de_groupsnav1(inputs)
});
export { groupsnav1 as "groupsNav" }